/** Compact action button used in the Select-mode toolbar. Icon+label on
 *  desktop, icon-forward on mobile so 4 actions fit. */
export const ActionBtn = ({ testId, onClick, disabled, icon, label, tone }) => {
  const bg = tone === "danger"
    ? "bg-rust hover:bg-rust/90"
    : tone === "primary"
      ? "bg-leaf hover:bg-leaf/90"
      : "bg-white/10 hover:bg-white/15";
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      aria-label={label}
      title={label}
      className={`text-xs inline-flex items-center gap-1.5 px-2.5 md:px-3 py-1.5 rounded-full ${bg} disabled:opacity-50 transition whitespace-nowrap`}
    >
      {icon}
      <span className="hidden md:inline">{label}</span>
    </button>
  );
};

export default ActionBtn;
